// removed by extract-text-webpack-plugin
module.exports = {"container":"_1SZ8","ie":"_3pCM","logo":"_2DC-","textLogo":"cWuH","wrapper":"_2jxh","contentContainer":"lc4A","title":"_3N83"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CaseStudy/Hero/styles.scss
// module id = 524
// module chunks = 0